import { SafeJSON } from './../shared/safe-json';
import { CaseIdentifier } from './../shared/case-identifier';
import { FileNumberUtil } from './../shared/file-number-util';
import { CivilIdentityOtherData } from './civil-identity-other-data';

export class CivilIdentitySearchCase {
    json: any;
    caseIdentifier: CaseIdentifier;

    // variables for loading other data
    otherData: CivilIdentityOtherData;

    constructor(json: any) {
        this.caseIdentifier =
            new CaseIdentifier('CIVIL',
                json.caseNumber.county,
                json.caseNumber.fileNumber);
        this.json = json;
        this.otherData = null;
    }

    getCaseIdentifier(): CaseIdentifier {
        return this.caseIdentifier;
    }

    isOtherDataPresent(): boolean {
        return !!this.otherData;
    }

    isPartyNameAsAlias(): boolean {
       let isPartyAlias: any = SafeJSON.get('partyName.alias', this.json);
       return isPartyAlias;
    }
    isPartyNameChanged(): boolean {
        let isPartyNameChanged: any = SafeJSON.get('partyName.nameChanged', this.json);
       return isPartyNameChanged;
    }
    getPartyName(): string {
       let partyPrevName: any = SafeJSON.get('partyName.prevName', this.json);
       return partyPrevName;
    }
    getPartyChangedToName(): string {
       let partyName: any = SafeJSON.get('partyName.name', this.json);
       return partyName;
    }
    getPartyAliasCount() {
        return 0;  // not defined yet
    }
    getPartyOtherPartyCount() {
       return 0; // not defined yet
    }
    getPartyRole(): string {
        return SafeJSON.get('partyRole', this.json);
    }
    getPartyRoleCode(): string {
       let partyRoleDesc = this.getPartyRole();
       return FileNumberUtil.getPartyRoleCode(partyRoleDesc);
    }
    getPartyTitle(): string {
      if (this.otherData) {
          return this.otherData.getPartyTitle();
      }
      return '';
    }
    getPartyNumber(): number {
       return SafeJSON.get('partyNumber', this.json);
    }
    getPartyStatus(): string {
       return SafeJSON.get('partyStatus', this.json);
    }
    getPartyEntryTime(): string {
       return SafeJSON.get('entTs', this.json);
    }
    getIssueEntryTime(): string {
      return  SafeJSON.get('issue.issueTs', this.json);
    }
    getRowOrigin(): string {
       return  SafeJSON.get('rowOrigin', this.json);
    }
    getOtherEntryTime(): string {
      if ('TRN' === this.getRowOrigin()) {
          return SafeJSON.get('otherTs', this.json);
      }
      return this.getIssueEntryTime();
    }
    getInRegardsTo(): string {
       if (this.otherData !== null && this.otherData !== undefined) {
          if (this.otherData.errorMessage) {
              return '___';
          }
         return this.otherData.getInRegardsTo();
       }
       return '';
    }
    getInRegardsToChangedFromOrTo() {
       return '';
    }
    getInRegardsToAliasCount() {
       if (this.otherData) {
           return this.otherData.getInRegardsToAliasCount();
       }
       return 0;
    }
    getInRegardsToPartyCount() {
       if (this.otherData) {
           return this.otherData.getInRegardsToPartyCount();
       }
       return 0;
    }
    getInRegardsToPartyRole(): string {
       if (this.otherData) {
          return this.otherData.getInRegardsToPartyRole();
       }
       return '';
    }
    getInRegardsToPartyTitle(): string {
        if (this.otherData) {
            return this.otherData.getInRegardsToPartyTitle();
        } else {
            return '';
        }
    }
    getCaseNumber(): string { // case file numeber without century (also insert middle zeros)
        let caseNumber: string =  SafeJSON.get('caseNumber.fileNumber', this.json);
        let caseType: string = FileNumberUtil.getCaseType(caseNumber);
        let caseTypeIndex: number = caseNumber.indexOf(caseType);
        if (caseTypeIndex > 2 ) {
           caseNumber =  caseNumber.substr(2);
        }

        return caseNumber;
    }
    getCaseNumberFull(): string {  // case file number with century
        return SafeJSON.get('caseNumber.fileNumber', this.json);
    }
    getRealCaseNumber(): string {
        return SafeJSON.get('realCaseNumber', this.json);
    }
    getCaseCounty(): string {
        return SafeJSON.get('caseNumber.county', this.json);
    }
    getCaseCountyCode() {
        return SafeJSON.get('caseNumber.countyCode', this.json);
    }
    getCaseStatus(): string {
       // return SafeJSON.getWithDefault('caseStatus.code', this.json);
       if (this.otherData) {
        if (this.otherData.errorMessage) {
            return '___';
        }
          return this.otherData.getCaseStatus();
       }
       return '';
    }
    getCaseStatusDescription(): string {
      // return SafeJSON.getWithDefault('caseStatus.description', this.json);
      if (this.otherData) {
        if (this.otherData.errorMessage) {
            return '___';
        }
        return this.otherData.getCaseStatus();
      }
      return '';
    }

    getCaseTypeDescription(): string {
       return SafeJSON.getWithDefault('caseNumber.courtDesc', this.json);
    }
    getCaseCaption(): string {
       return '* Not yet implemented';
    }
    getInitiatingPleadingAndIssue(): string {
       return '* Not yet implemented';
    }

    // ??? - it is the same as the one in CivilCase.ts
    getJudgmentDocketedAndIndexed(): string {
       return SafeJSON.get('hasJudgement', this.json) ? 'YES' : 'NO';
    }

    getOpposingPartyName(): string {
       if (this.otherData) {
           if (this.otherData.errorMessage) {
               return '___';
           }
           return this.otherData.getOpposingPartyName();
       }
       return '';
    }

    getOpposingPartyAliasCount(): number {
       if (this.otherData) {
           return this.otherData.getOpposingPartyAliasCount();
       }
       return 0;
    }

    getOpposingOtherPartyCount(): number {
      if (this.otherData) {
         return this.otherData.getOpposingOtherPartyCount();
      }
      return 0;
    }

    getOpposingPartyRole(): string {
      if (this.otherData) {
        return this.otherData.getOpposingPartyRole();
      }
      return '';
    }

    getOpposingPartyTitle(): string {
        if (this.otherData) {
          return this.otherData.getOpposingPartyTitle();
        }
        return '';
      }

    getIssue(): string {
       return SafeJSON.getWithDefault('issue.type', this.json);
    }

    getIssueDescription(): string {
        if (this.getIssue() === '9999') {  // hard codeed for now
            return 'NO ISSUE IS ASSOCIATED WITH PARTY';
        }
        return SafeJSON.getWithDefault('issue.description', this.json);
    }

    getJudgmentLocation(): string {
        if (this.otherData) {
            if (this.otherData.errorMessage) {
                return '___';
            }
            return this.otherData.getJudgmentLocation();
        }
        return '';
    }

    getJudgmentStatus(): string {
        if (this.otherData) {
            return this.otherData.getJudgmentStatus();
        }
        return '';
    }

    getTranscriptedToCounty(): string {
        return SafeJSON.get('caseNumber.transcriptedToCounty', this.json);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-identity-search-case.ts